import type { ClickoutUrl } from '@/helpers/clickout-helper';
import { getJWTVTitleUrl, JWTVQueryParamMapping, type JWTVQueryParams } from '@/helpers/jwtv-helper';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { useRouter } from 'vue-router/composables';

export function useJWTV() {
	const router = useRouter();
	const routingStore = useRoutingStore();

	function clearJWTVQueryParams() {
		const clearedParams = Object.fromEntries(Object.keys(JWTVQueryParamMapping).map(key => [key, undefined]));
		router.replace({ query: { ...routingStore.activeRoute?.query, ...clearedParams } });
	}

	function openJWTVTitleDetail({
		clickoutUrl,
		fullPath,
		extra,
	}: {
		clickoutUrl: ClickoutUrl;
		fullPath: string;
		extra?: JWTVQueryParams;
	}) {
		const linkContextId = clickoutUrl.contexts?.LinkContext?.link?.self ?? undefined;

		const url = getJWTVTitleUrl({ fullPath, linkContextId, ...extra });

		router.push(url!);
	}

	return { clearJWTVQueryParams, openJWTVTitleDetail };
}
